const MAPS_SERVER_URL = process.env.SERVER_URL || location.origin;

export function createURL(path: string) {
  return MAPS_SERVER_URL + path;
}
